export const SETTING_SHOW_START = 'SETTING_SHOW_START';
export const SETTING_SHOW_SUCCESS = 'SETTING_SHOW_SUCCESS';
export const SETTING_SHOW_FAILURE = 'SETTING_SHOW_FAILURE';

export const SSH_CONNECT_START = 'SSH_CONNECT_START';
export const SSH_CONNECT_SUCCESS = 'SSH_CONNECT_SUCCESS';
export const SSH_CONNECT_FAILURE = 'SSH_CONNECT_FAILURE';

export const RDP_FILE_DOWNLOAD_START = 'RDP_FILE_DOWNLOAD_START';
export const RDP_FILE_DOWNLOAD_SUCCESS = 'RDP_FILE_DOWNLOAD_SUCCESS';
export const RDP_FILE_DOWNLOAD_FAILURE = 'RDP_FILE_DOWNLOAD_FAILURE';

export const SESSION_TOKEN_START = 'SESSION_TOKEN_START';
export const SESSION_TOKEN_SUCCESS = 'SESSION_TOKEN_SUCCESS';
export const SESSION_TOKEN_FAILURE = 'SESSION_TOKEN_FAILURE';

export const ERROR_RESET = 'ERROR_RESET';

export const FATAL_FAILURE = 'SYSTEM_FAILURE';

export const CLEAR_ALL = 'CLEAR_ALL';
